// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"c--z","button":"d--z","disabled":"e--z","creditCard":"f--z","wrapper":"g--z"};